import { useState, useEffect, useRef } from "react";
import regada_picture from "../images/logoTYPOGRAPHIAwhite.svg";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Loading from "../components/LoadingScreen";

const Final = () => {
  const serverAdresa = process.env.REACT_APP_API_URL;

  const location = useLocation();
  let vsetkyUdaje = location.state.vsetkyUdaje;
  let stlaceneCele = location.state.stlaceneCele;
  let objednavacieCisla = location.state.objednavacieCisla;
  let typove = location.state.typove;
  let nazov = vsetkyUdaje.nazov;

  let meno = location.state.meno;
  let firma = location.state.firma;
  let email = location.state.email;
  let tel = location.state.tel;
  let oznacenie = location.state.oznacenie;
  let sprava = location.state.sprava;

  let ktoryNazov = location.state.ktoryNazov;
  let celyRiadok = location.state.celyRiadok;

  // nove ku cenniku
  let zakladnaCena = location.state.zakladnaCena;
  let priplatkovaCena = location.state.priplatkovaCena;

  let obchodak = location.state.obchodak;

  let zakladnaZlava = location.state.zakladnaZlava;
  let rozsirenaZlava = location.state.rozsirenaZlava;

  function removeNonStrings(data) {
    return data.map((arr) => arr.filter((item) => typeof item === "string"));
  }

  // CENA celkova
  function sumNumbers(data) {
    return data.reduce(
      (sum, arr) =>
        sum +
        arr.reduce(
          (innerSum, item) =>
            typeof item === "number" ? innerSum + item : innerSum,
          0
        ),
      0
    );
  }

  // console.log(sumNumbers(celyRiadokCely));
  let rozsireneVsetky = location.state.rozsireneVsetky;

  let zakaznicke = location.state.zakaznicke;
  let zakaznickeVyhotovenieNajdene =
    location.state.zakaznickeVyhotovenieNajdene;

  let slovnik = location.state.slovnik;
  let selectedLanguage = location.state.selectedLanguage;

  let poznamka = location.state.poznamka;
  let najdenePoznamky = location.state.najdenePoznamky;

  let isFinal = true;

  const timeElapsed = Date.now();
  const today = new Date(timeElapsed);
  const formattedDate = `${today.getDate()}.${
    today.getMonth() + 1
  }.${today.getFullYear()}`;

  const [pdfUrl, setPdfUrl] = useState(null);
  const [nacitava, setNacitava] = useState(false);

  const prveSpustenie = useRef(false);

  const fetchPDF = async () => {
    setNacitava(true);
    try {
      const response = await axios.post(
        `${serverAdresa}generatePDF`,
        {
          isFinal,
          nazov,
          formattedDate,
          typove,
          ktoryNazov,
          celyRiadok,
          stlaceneCele,
          rozsireneVsetky,
          objednavacieCisla,
          zakaznicke,
          zakaznickeVyhotovenieNajdene,
          slovnik,
          selectedLanguage,
          meno,
          firma,
          email,
          tel,
          oznacenie,
          sprava,
          poznamka,
          najdenePoznamky,
          zakladnaCena,
          priplatkovaCena,
        },
        {
          responseType: "blob", // Specify the response type
        }
      );

      const pdfUrl = URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      setPdfUrl(pdfUrl);
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
    setNacitava(false);
  };

  // pridatDoHistorie

  useEffect(() => {
    if (prveSpustenie.current === false) {
      // do fetch dat aj cislovanie
      fetchPDF();
      return () => (prveSpustenie.current = true);
    }
  }, []);

  return (
    <>
      {" "}
      {nacitava && <Loading />}
      {!nacitava && (
        <>
          <div id="headerup-final">
            {" "}
            <a
              id="typo_obal"
              href="https://www.regada.sk/elektricke-servopohony"
            >
              <img
                src={regada_picture}
                id="typografia_header"
                alt="typography"
              ></img>
            </a>
          </div>
          <div>
            {/* <div>Cena: {sumNumbers(celyRiadokCely)}</div> */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {obchodak ? (
                <div style={{ marginTop: "20px" }}>
                  <h2>
                    Základna cena: {zakladnaCena}€ ({zakladnaZlava}%)
                  </h2>
                  <h2>
                    Príplatková cena: {priplatkovaCena}€ ({rozsirenaZlava}%)
                  </h2>
                  <h2>Spolu: {zakladnaCena + priplatkovaCena}€</h2>
                </div>
              ) : null}
              <div className="final_info">
                {pdfUrl && (
                  <iframe
                    title="PDF Preview"
                    className="pdf_final"
                    src={pdfUrl}
                    width="1020px"
                    height="1000px"
                    style={{ marginLeft: "30px" }}
                  />
                )}
                <a href="https://www.regada.sk/elektricke-servopohony">
                  <div className="tlacitko" style={{ margin: "0 0 0 10px" }}>
                    Koniec
                  </div>
                </a>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Final;
